import React from 'react'
import { Link } from 'react-router-dom'

// Components
import NextArrow from '../NextArrow'

// Styles
import './index.scss'

const Media = (props) => {
  const { className, link, head, content } = props

  return (
    <div className={`media-bg ${className}`}>
      <div className={`inner white`}>
        {
          link ?
            <Link to={link}>
              <h2>{head}</h2>
              <p>{content}</p>
              <NextArrow />
            </Link>

            :
            <React.Fragment>
              <h2>{head}</h2>
              <p>{content}</p>
            </React.Fragment>
        }
      </div>
      {className.includes('bg-content') ? null : <div className="overlay"></div>}
    </div>
  )
}

export default Media